import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-p-line",
  "use": "icon-p-line-usage",
  "viewBox": "0 0 26 27",
  "content": "<symbol viewBox=\"0 0 26 27\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-p-line\">\n    <g id=\"icon-p-line_Frame\">\n        <path id=\"icon-p-line_Vector\" d=\"M3.484 23.42L22.7459 4.15806L22.1715 3.58362L2.90956 22.8456L3.484 23.42Z\" />\n    </g>\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol